import queryString from "query-string";
import { useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import { BarTypes } from "store/types";

export interface IUseDealParamsHooks {
  dealId: number;
  formId: number;
  sectionId: number;
  barContent?: BarTypes;
  fileId: number;
  folderId: number;
  emailId: number;
  answerUuid?: string | null | string[];
  noteId: number;
  task?: number;
  userManagement?: string;
  teamManagement?: string;
}
// https://fo1.altius.finance/deal/42?questionnaire=146&section=78&bar
// =comments&comment=412&question-uuid=aac3d08f-6aec-452c-a1d6-ade3d7256560&reply=403

export function useDealParamsHooks(): IUseDealParamsHooks {
  const { location } = useHistory();
  const routeParams: { [key: string]: any } = useParams();

  const queryParams = useMemo(() => {
    return queryString.parse(location.search);
  }, [location.search]);

  const dealId = useMemo(() => {
    return Number(routeParams.deal_id);
  }, [routeParams]);

  const formId = useMemo(() => {
    return Number(routeParams.form_id);
  }, [routeParams]);

  const sectionId = useMemo(() => {
    return Number(queryParams.section);
  }, [queryParams.section]);

  const barContent: BarTypes | undefined = useMemo(() => {
    return queryParams?.bar?.toString() as BarTypes | undefined;
  }, [queryParams]);

  const fileId: number = useMemo(() => {
    return Number(routeParams.file_id);
  }, [routeParams]);

  const folderId: number = useMemo(() => {
    return Number(routeParams.folder_id);
  }, [routeParams]);

  const answerUuid: string | null | string[] | any = useMemo(() => {
    return queryParams.answer;
  }, [queryParams]);

  const emailId: number = useMemo(() => {
    return Number(routeParams.email_id);
  }, [routeParams]);

  const noteId: number = useMemo(() => {
    return Number(routeParams.note_id);
  }, [routeParams]);

  const task: number | undefined = useMemo(() => {
    if (queryParams.task) {
      return Number(queryParams.task);
    }
  }, [queryParams]);

  const teamManagement = useMemo(() => {
    if (queryParams.teamManagement) {
      return String(queryParams.teamManagement);
    }
  }, [queryParams]);

  const userManagement = useMemo(() => {
    if (queryParams.userManagement) {
      return String(queryParams.userManagement);
    }
  }, [queryParams]);

  return {
    dealId,
    formId,
    sectionId,
    barContent,
    fileId,
    folderId,
    answerUuid,
    emailId,
    noteId,
    task,
    userManagement,
    teamManagement
  };
}
